var url = "a507904b8abab284290c40909d3f1da2.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;